(() => {
  if (customElements.get('eyewear-thumbnail')) return;
  class EyewearThumbnail extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.image = this.querySelector('img');
      if (!this.image) return;
      this.image.addEventListener('load', () => this.measure());
      this.observer = new ResizeObserver(() => this.layout());
      this.observer.observe(this);
      if (this.image.complete && this.image.naturalWidth) this.measure();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    measure() {
      try {
        const image = this.image;
        const ratio = Math.min(1, 384 / image.naturalWidth);
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(image.naturalWidth * ratio);
        canvas.height = Math.round(image.naturalHeight * ratio);
        const context = canvas.getContext('2d', { willReadFrequently: true });
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        const pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
        let left = canvas.width, right = 0, top = canvas.height, bottom = 0, count = 0;
        for (let y = 0; y < canvas.height; y++) {
          for (let x = 0; x < canvas.width; x++) {
            const i = (y * canvas.width + x) * 4;
            const min = Math.min(pixels[i], pixels[i + 1], pixels[i + 2]);
            const max = Math.max(pixels[i], pixels[i + 1], pixels[i + 2]);
            if (pixels[i + 3] > 120 && (min < 140 || (max - min > 25 && min < 210))) {
              left = Math.min(left, x); right = Math.max(right, x);
              top = Math.min(top, y); bottom = Math.max(bottom, y); count++;
            }
          }
        }
        if (count < 40 || right - left < canvas.width * .15) return;
        this.bounds = { x: left / ratio, y: top / ratio, width: (right - left + 1) / ratio, height: (bottom - top + 1) / ratio };
        this.layout();
      } catch {}
    }
    layout() {
      if (!this.bounds || !this.isConnected) return;
      const box = this.getBoundingClientRect(), bounds = this.bounds;
      if (!box.width || !box.height) return;
      const scale = Math.min(box.width * .9 / bounds.width, box.height * .82 / bounds.height);
      Object.assign(this.image.style, {
        position: 'absolute', maxWidth: 'none', maxHeight: 'none', margin: '0', objectFit: 'contain',
        width: `${this.image.naturalWidth * scale}px`, height: `${this.image.naturalHeight * scale}px`,
        left: `${(box.width - bounds.width * scale) / 2 - bounds.x * scale}px`,
        top: `${(box.height - bounds.height * scale) / 2 - bounds.y * scale}px`
      });
    }
  }
  customElements.define('eyewear-thumbnail', EyewearThumbnail);
})();
